import React from 'react';

const isStaging = process.env.REACT_APP_NODE_ENV === 'staging';

const StagingBanner = () => {
  if (!isStaging) {
    return null;
  }

  return <div className="staging-banner">Esta es la plataforma de pruebas</div>;
};

export default StagingBanner;
